import { HStack, Link as TriggerLink } from "@chakra-ui/react"
import AssetLink from "@hydrologiq/shared/asset/AssetLink"
import Popover from "@hydrologiq/shared/chakra/Popover"
import EntityPopoverList from "../popovers/EntityPopoverList"

interface Asset {
  id: string
  name: string
}

interface MultiAssetDisplayProps {
  assets: Asset[]
  maxVisible?: number
}

/**
 * Display multiple assets with a "show more" popover for overflow.
 * Shows first N assets inline, with remaining assets in a popover.
 */
export const MultiAssetDisplay: React.FC<MultiAssetDisplayProps> = ({ assets, maxVisible = 1 }) => {
  if (!assets || assets.length === 0) {
    return <span>-</span>
  }

  // Single asset - display directly
  if (assets.length === 1) {
    return (
      <AssetLink asset={assets[0]} openExternal={true} />
    )
  }

  // Multiple assets - show first N + popover for rest
  const visibleAssets = assets.slice(0, maxVisible)
  const remainingAssets = assets.slice(maxVisible)
  const remainingCount = remainingAssets.length

  return (
    <HStack gap={2} flexWrap="wrap">
      {visibleAssets.map((asset) => (
        <AssetLink asset={asset} openExternal={true} key={asset.id} />
      ))}
      {remainingCount > 0 && (
        <Popover
          trigger={<TriggerLink variant="secondary" fontSize="1em">+{remainingCount} more</TriggerLink>}
          showArrow={true}
          placement="bottom"
          width="17.5rem"
          closeOnOutside
        >
          <EntityPopoverList
            title="Assets"
            count={remainingCount}
            items={remainingAssets.map((asset) => ({
              id: asset.id,
              name: asset.name,
              href: `/assets/${asset.id}`,
              openExternal: true,
            }))}
          />
        </Popover>
      )}
    </HStack>
  )
}








